export default __webpack_public_path__ + "assets/search.9e51058d.svg";